import React from "react";

export default function AIFitScoreBadge({ score, label = "AI Fit Score" }) {
  const display = score == null ? "—" : Number(score).toFixed(1);
  return (
    <div
      className="inline-flex items-center gap-2 px-3 py-1.5 bg-black border border-brand glow-brand rounded-md"
      data-testid="ai-fit-score"
    >
      <span className="overline text-[#FF4500]">{label}</span>
      <span className="font-mono text-brand text-base font-bold">{display}</span>
    </div>
  );
}
